var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"default-title-wrapper",style:({
    borderColor: _vm.theme,
    width: _vm.width ? `${_vm.width}px` : '',
    'text-align': _vm.width ? 'right' : 'left',
  })},[_c('span',{staticClass:"title",style:({
      color: _vm.theme,
      'max-width': _vm.cvDetail.format_info.top_format === 'left_form' ? '112px' : '',
    })},[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }